module.exports = __webpack_public_path__ + "static/media/ends_with_k.8b1844cf.mp3";